import MarkerSymbol from './MarkerSymbol';

/**
 * 文字、图片符号类，主要用于‘显示文字’功能.
 */
export default class TextImageSymbol extends MarkerSymbol {
    constructor(options) {
        // 执行父类初始化
        super(options);

        // 文字的默认属性
        this.type = 'TextImageSymbol';
        this.text = ''; // 文本信息
        this.font = '宋体'; // 字体
        this.size = 10; // 字体大小
        this.fontHeight = 21; // 文字高度（文字高度、宽度与文字大小不冲突，主要用于计算外边框大小）
        this.fontWidth = 22;// 文字宽度
        this.fontColor = '#000'; // 字体颜色
        this.hasImage = false; // 是否含有图片
        this.letterSpace = 2; // 字间距

        // 图片的默认属性
        this.url = ''; // 图片URL
        this.lineColor = this.fontColor; // 外形边框颜色
        this.lineWidth = 1; // 外边框宽度
        this.pCX = 100; // 图片中心坐标
        this.pCY = 100; // 图片中心坐标
        this.width = 21; // 图片所在框的宽度
        this.height = 22; // 图片所在框的高度
        this.pWidth = 16; // 呈现图片宽度
        this.pHeight = 16; // 呈现图片的高度
        this.sourceX = 100; // 原始坐标
        this.sourceY = 100;

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('text', json.text);
        this._setValue('font', json.font);
        this._setValue('fontHeight', json.fontHeight);
        this._setValue('fontWidth', json.fontWidth);
        this._setValue('size', json.size);
        this._setValue('fontColor', json.fontColor);
        this._setValue('hasImage', json.hasImage);
        this._setValue('letterSpace', json.letterSpace);

        this._setValue('url', json.url);
        this._setValue('lineColor', json.lineColor);
        this._setValue('lineWidth', json.lineWidth);
        this._setValue('pCX', json.pCX);
        this._setValue('pCY', json.pCY);
        this._setValue('width', json.width);
        this._setValue('height', json.height);
        this._setValue('pWidth', json.pWidth);
        this._setValue('pHeight', json.pHeight);
        this._setValue('sourceX', json.sourceX);
        this._setValue('sourceY', json.sourceY);
    }

    toJson() {
        const json = super.toJson();

        json.text = this.text;
        json.font = this.font;
        json.fontHeight = this.fontHeight;
        json.fontWidth = this.fontWidth;
        json.size = this.size;
        json.fontColor = this.fontColor;
        json.hasImage = this.hasImage;
        json.letterSpace = this.letterSpace;

        json.url = this.url;
        json.lineColor = this.lineColor;
        json.pCX = this.pCX;
        json.pCY = this.pCY;
        json.width = this.width;
        json.height = this.height;
        json.pWidth = this.pWidth;
        json.pHeight = this.pHeight;
        json.sourceX = this.sourceX;
        json.sourceY = this.sourceY;
        return json;
    }

    draw(ctx, geometry) {
        // 保存当前状态，方便绘制完成后恢复状态
        this._save(ctx, geometry);

        this._setTransformation(ctx, geometry);
        const textParam = this.drawText(ctx);
        this.drawOutline(ctx, textParam);
        if (this.hasImage) {
            this.drawImage(ctx);
        }
        // 绘制完成后恢复到上次保存的状态，避免影响以后的绘制
        this._restore(ctx);
    }

    /**
     * 绘制文本内容
     * @param {Object} ctx canvas文本对象
     */
    drawText(ctx) {
        const px = 'px ';
        ctx.font = this.size + px + this.font;
        ctx.fillStyle = this.fontColor;
        ctx.lineWidth = this.lineWidth;
        
        const allW = this.text.length * this.size + this.letterSpace * (this.text.length - 1);
        let showY = this.size * 0.4;
        if (this.hasImage) {
            showY = -this.height * 0.5 - this.fontHeight * 0.5 + this.size * 0.4;
        }
        const showX = -this.text.length * this.size * 0.5;
        ctx.fillText(this.text, showX, showY);
        return { allWidth: allW, allHeight: this.size * 1.2 };
    }

    /**
     * 主要用于图片显示正确性的验证，实际不调用
     */
    drawPoint(ctx) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(0, 0, 2, 0, Math.PI * 2);
        ctx.fillStyle = '#ff0000'; // 设置填充颜色
        ctx.fill(); // 填充颜色
        ctx.closePath(); // 关闭绘制路径
        ctx.restore();
    }

    /**
     * 绘制文字以及图片外形边框
     * @param {Object} ctx canvas 文本对象
     * @param {Object} textParam 文本对象内容
     */
    drawOutline(ctx, textParam) {
        const allW = this.text.length * this.fontWidth + (this.text.length - 1) * this.letterSpace;
        const allH = this.fontHeight;
        let linePoint;

        if (!this.hasImage) {
            const minX = -allW / 2 - this.size * 0.2;
            const maxX = allW / 2 + this.size * 0.2;
            const minY = -allH * 0.5;
            const maxY = allH * 0.5;
            linePoint = [[minX, minY], [minX, maxY], [maxX, maxY], [maxX, minY]];
        } else {
            const minX = -allW / 2 - this.size * 0.2;
            const maxX = allW / 2 + this.size * 0.2;
            const minY = -allH - this.height * 0.45;
            const maxY = -this.height * 0.45;

            const pW = this.width;
            const pH = this.height;
            const pMinX = -pW * 0.6;
            const pMaxX = pW * 0.6;
            const pMaxY = maxY + pH + pH * 0.1;
            linePoint = [[minX, minY], [maxX, minY], [maxX, maxY], [pMaxX, maxY], [pMaxX, pMaxY],
                         [pMinX, pMaxY], [pMinX, maxY], [minX, maxY]];
        }


        ctx.strokeStyle = this.lineColor;
        ctx.beginPath();
        ctx.moveTo(linePoint[0][0], linePoint[0][1]);
        for (let i = 1; i < linePoint.length; i++) {
            ctx.lineTo(linePoint[i][0], linePoint[i][1]);
        }
        ctx.closePath();
        ctx.stroke();
    }

    /**
     * 绘制图片
     * @param {Object} ctx canvas文本对象
     */
    drawImage(ctx) {
        const img = this._resourceFactory.get(this.url);
        ctx.drawImage(img, this.pCX, this.pCY, this.pWidth, this.pHeight);
    }
}
